<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect x="6" y="6" width="8" height="8" fill="white" />
        <path
            d="M15.3079 3.75H13.2759V6.69453H16.2493V4.58028C16.2501 4.58028 16.1024 3.8303 15.3079 3.75Z"
            fill="#1967D2"
        />
        <path
            d="M13.2764 16.2356V16.2428V16.2492L16.2498 13.3047H16.2231L13.2764 16.2356Z"
            fill="#1967D2"
        />
        <path
            d="M16.2495 13.3057V13.2793L16.2231 13.3057H16.2495Z"
            fill="#FBBC05"
        />
        <path
            d="M16.2498 6.69531H13.2764V13.2798H16.2498V6.69531Z"
            fill="#FBBC05"
        />
        <path
            d="M16.2231 13.3047H13.2764V16.2356L16.2231 13.3047Z"
            fill="#EA4335"
        />
        <path
            d="M13.2764 13.3057H16.2231L16.2498 13.2793H13.2764V13.3057Z"
            fill="#EA4335"
        />
        <path
            d="M13.2695 16.2435H13.2767V16.2363L13.2695 16.2435Z"
            fill="#34A853"
        />
        <path
            d="M6.65625 13.2793V16.2439H13.2691L13.2764 13.2793H6.65625Z"
            fill="#34A853"
        />
        <path
            d="M13.2767 13.3058V13.2793L13.2695 16.2439L13.2767 16.2367V13.3058Z"
            fill="#34A853"
        />
        <path
            d="M3.75 13.2793V15.3405C3.77664 16.0094 4.50002 16.2439 4.50002 16.2439H6.65641V13.2793H3.75Z"
            fill="#188038"
        />
        <path
            d="M6.65641 6.69453H13.2766V3.75H4.58398C4.58398 3.75 3.80328 3.8303 3.75 4.65978V13.279H6.65641V6.69453Z"
            fill="#4285F4"
        />
        <path
            d="M8.82231 11.9458C8.67086 11.9458 8.52481 11.9261 8.38417 11.8866C8.24714 11.8472 8.12093 11.788 8.00553 11.7091C7.89014 11.6266 7.78736 11.5244 7.69721 11.4024C7.61066 11.2805 7.54395 11.1388 7.49707 10.9774L8.1624 10.7138C8.20928 10.8931 8.28861 11.0294 8.4004 11.1227C8.51219 11.2123 8.65283 11.2572 8.82231 11.2572C8.89804 11.2572 8.97016 11.2464 9.03868 11.2249C9.1072 11.1998 9.1667 11.1657 9.21718 11.1227C9.26767 11.0796 9.30734 11.0294 9.33618 10.972C9.36864 10.9111 9.38487 10.8429 9.38487 10.7676C9.38487 10.6098 9.32537 10.486 9.20636 10.3964C9.09097 10.3067 8.9305 10.2619 8.72495 10.2619H8.40581V9.62166H8.6979C8.77003 9.62166 8.84034 9.6127 8.90886 9.59476C8.97738 9.57683 9.03688 9.54993 9.08736 9.51406C9.14145 9.47461 9.18292 9.42619 9.21177 9.3688C9.24423 9.30783 9.26046 9.23789 9.26046 9.15898C9.26046 9.03704 9.21718 8.93841 9.13064 8.86309C9.04409 8.78418 8.92689 8.74473 8.77904 8.74473C8.62037 8.74473 8.49776 8.78777 8.41122 8.87385C8.32828 8.95634 8.27058 9.04959 8.23813 9.1536L7.58903 8.88999C7.62148 8.80032 7.67016 8.70886 7.73507 8.61561C7.79998 8.51877 7.88112 8.43269 7.97849 8.35737C8.07946 8.27846 8.19665 8.2157 8.33008 8.16907C8.46351 8.11886 8.61677 8.09375 8.78986 8.09375C8.96656 8.09375 9.12703 8.11886 9.27127 8.16907C9.41912 8.21928 9.54534 8.28922 9.64992 8.37889C9.75449 8.46497 9.83563 8.56898 9.89333 8.69093C9.95103 8.80929 9.97987 8.93841 9.97987 9.07828C9.97987 9.18588 9.96545 9.28272 9.9366 9.3688C9.91136 9.45488 9.8771 9.532 9.83383 9.60014C9.79055 9.66829 9.74007 9.72747 9.68237 9.77768C9.62828 9.82431 9.57238 9.86197 9.51469 9.89066V9.9337C9.68778 10.0018 9.83022 10.1112 9.94201 10.2619C10.0574 10.4125 10.1151 10.6026 10.1151 10.8322C10.1151 10.9936 10.0845 11.1424 10.0231 11.2787C9.96184 11.4114 9.87349 11.528 9.7581 11.6284C9.64631 11.7288 9.51108 11.8059 9.35241 11.8597C9.19374 11.9171 9.01704 11.9458 8.82231 11.9458Z"
            fill="#4285F4"
        />
        <path
            d="M11.4068 11.8597V9.00835L10.7523 9.28272L10.4927 8.68555L11.5799 8.17983H12.1154V11.8597H11.4068Z"
            fill="#4285F4"
        />
    </svg>
</template>
